const refreshInterval = 30;
export const remainingSeconds = ref(refreshInterval);

export const usePolling = () => {
  const GFALExStore = useGFALExStore();

  const refreshPriceInfo = async () => {
    await GFALExStore.getGFALExSnapshot();
    useNotifications().updateUnreadNotificationsCount();
    logWarning();
    remainingSeconds.value = refreshInterval;
  };
  const initRateRefresh = () => {
    if (!import.meta.client) return;
    setInterval(refreshPriceInfo, refreshInterval * 1000);
    setInterval(() => {
      remainingSeconds.value--;
    }, 1000);
  };

  return {
    initRateRefresh,
  };
};
